// No longer managed by Amplify backend, this may be edited now

// For Dev with new signup flow
const REGION = import.meta.env.VITE_REGION || 'us-west-2';
const USER_POOL_REGION = import.meta.env.VITE_USER_POOL_REGION || 'us-west-2';
const USER_POOL_ID = import.meta.env.VITE_USER_POOL_ID || 'IPrFnT79V';
const USER_POOL_CLIENT_ID = import.meta.env.VITE_USER_POOL_CLIENT_ID || '6k2dift2qvf1nsqno31vpvn21e';
const REDIRECT_URL = import.meta.env.VITE_REDIRECT_URL || 'http://localhost:3000';
const AUTH_DOMAIN = import.meta.env.VITE_AUTH_DOMAIN || 'auth.dev.planera.io';

export const awsmobile = {
  aws_project_region: REGION,
  aws_cognito_region: USER_POOL_REGION,
  aws_user_pools_id: USER_POOL_REGION + '_' + USER_POOL_ID,
  aws_user_pools_web_client_id: USER_POOL_CLIENT_ID,
  oauth: {
    // TODO: This pattern may not hold for all regions
    domain: AUTH_DOMAIN,
    scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'phone', 'profile'],
    redirectSignIn: REDIRECT_URL,
    redirectSignOut: REDIRECT_URL + '/logout',
    responseType: 'token'
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: ['REQUIRES_LOWERCASE', 'REQUIRES_UPPERCASE', 'REQUIRES_NUMBERS', 'REQUIRES_SYMBOLS']
  },
  aws_cognito_verification_mechanisms: ['EMAIL']
};

export default awsmobile;
